<div class="row justify-content-center">
    <img src="assets/patch-circle.png" class="patch_circle" alt="">
</div>
<div class="row services_row_scroll">
    <figure class="effect-chico col-md-3 col-sm-3 m-0 p-0" style="    background: #303030;">
        <img class="bg" src="https://tympanus.net/Development/HoverEffectIdeas/img/15.jpg" alt="img15" />
        <figcaption class="images">
            <div class="imageInn">
                <img src="assets/pencil.png" class="image_service" alt="">
            </div>
            <div class="hoverImg">
                <img src="assets/pencil-hover.png" class=" image_service" alt="">
            </div>
            <h4 class="heading">Graphic <br> Design
            </h4>
            <br>
            <p>BRANDING

                <br> DIGITAL & PRINT MEDIA

                <br> ART & ILLUSTRATION MOTION GRAPHICS</p>
        </figcaption>
    </figure>
    <figure class="effect-chico col-md-3 col-sm-3 m-0 p-0" style="    background: #383838;">
        <img class="bg" src="https://tympanus.net/Development/HoverEffectIdeas/img/15.jpg" alt="img15" />
        <figcaption class="images">
            <div class="imageInn">
                <img src="assets/web-design.png" class="image_service" alt="">
            </div>
            <div class="hoverImg">
                <img src="assets/web-design-hover.png" class="image_service" alt="">
            </div>
            <h4 class="heading">Web <br> Development
            </h4>
            <br>
            <p>UI/UX

                <br> ECOMMERCE

                <br> CUSTOM WEBSITE GSAP, REACTJS</p>
        </figcaption>
    </figure>
    <figure class="effect-chico col-md-3 col-sm-3 m-0 p-0" style="    background: #3B3B3B;">
        <img class="bg" src="https://tympanus.net/Development/HoverEffectIdeas/img/15.jpg" alt="img15" />
        <figcaption class="images">
            <div class="imageInn">
                <img src="assets/settings.png" class="image_service" alt="">
            </div>
            <div class="hoverImg">
                <img src="assets/settings-hover.png" class="image_service" alt="">

            </div>
            <h4 class="heading">App <br> Development
            </h4>
            <br>
            <p>UI/UX

                <br> ANDROID

                <br> IOS FLUTTER, REACT NATIVE</p>
        </figcaption>
    </figure>
    <figure class="effect-chico col-md-3 col-sm-3 m-0 p-0" style="    background: #383838">
        <img class="bg" src="https://tympanus.net/Development/HoverEffectIdeas/img/15.jpg" alt="img15" />
        <figcaption class="images">
            <div class="imageInn">
                <img src="assets/social-media.png" class="image_service" alt="">
            </div>
            <div class="hoverImg">
                <img src="assets/social-media-hover.png" class="image_service" alt="">
            </div>
            <h4 class="heading">Digital <br> Marketing

            </h4>
            <p>SEO, SEM <br>
                <br> SOCIAL MEDIA

                <br> APP STORE OPTIMIZATION EMAIL MARKETING</p>
        </figcaption>
    </figure>
</div>